import { jsx as _jsx } from "react/jsx-runtime";
import useTicTacToeStore from "../lib/stores/ticTacToesStore";
const Header = () => {
    const { isXNext } = useTicTacToeStore();
    return (_jsx("div", { className: "w-full justify-center flex my-10", children: _jsx("p", { className: "text-4xl font-semibold", children: isXNext ? "X" : "O" }) }));
};
export default Header;
